module.exports = "<div #ngForTickets *ngFor=\"let ticket of tickets; let index = index\">\n  <app-print-single [additionalClasses]=\"'dotted'\" [ticket]=\"ticket\" [en]=\"en\" [num]=\"1\"></app-print-single>\n  <app-print-single [additionalClasses]=\"index+1 !== tickets.length ? 'pageBreak' : ''\" [ticket]=\"ticket\" [en]=\"en\" [num]=\"2\"></app-print-single>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/tickets/print/print.component.html
// module id = ./src/app/tickets/print/print.component.html
// module chunks = main